module.exports = __webpack_public_path__ + "static/media/accepted-card-logos.dc8eec22.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/accepted-card-logos.svg
// module id = 634
// module chunks = 0